import { Box, Button } from '@mui/material'
import logoImage from 'assets/logo-conducco.svg'
import WrapperPermission from 'components/wrapper-permission'
import { useCustomTheme } from 'contexts/theme'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useStyles } from './styles'

const EmailConfirmation: React.FC = () => {
  const [email, setEmail] = useState('')
  const { theme } = useCustomTheme()
  const classes = useStyles()

  // initial load

  useEffect(() => {
    async function loadData() {
      const transferData = localStorage.getItem('conducco')

      if (transferData) {
        const jsonData = JSON.parse(transferData)

        setEmail(jsonData.email)
      }
    }

    loadData()
  }, [])

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.leftBox}>
            <h1 className={classes.insideH1}>Confirme seu e-mail para acessar</h1>
            <p>
              Conducco criou o Cofre Digital, para dar controle às empresas na troca de dados corporativos de forma mais
              segura e conveniente, aderente às normas previstas na LGPD.
            </p>
            <p>
              A Conducco é construída sob tecnologias de governança de dados de nível mundial: Snowflake e Amazon Web
              Services.
            </p>
            <p>Saiba mais sobre nossas Política de Dados.</p>
            <Box className={classes.loginImage}>
              <img
                src={theme.name === 'custom' ? theme.logo.base : `/${theme.name}/logo.svg`}
                className={classes.logoImage}
                alt='Logo'
              />
            </Box>
          </Box>
        </WrapperPermission>
        <Box className={classes.rightWrapper}>
          <Box
            component='form'
            noValidate
            data-testid='form'
            className={classes.formBox}
          >
            <img
              src={logoImage}
              className={classes.logoImage}
              alt='Logo'
            />

            <div className={classes.checkEmailHeader}>Confirmar endereço de email</div>

            <div className={classes.checkEmailBody}>
              Por favor, confirme que {email} é mesmo seu email para prosseguir.
            </div>

            <Button
              variant='outlined'
              component={Link}
              to={'/certificate-upload'}
              style={{ marginTop: '25px', padding: '15px 20px 15px 20px' }}
            >
              Confirmar
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmailConfirmation
